import { Injectable } from '@angular/core';

@Injectable()
export class CurrentDateService {
  /*
   * Use this service to set and retrieve current Date
   */

  private lastDate: Date; // Last date received
  private updatedAt: Date; // When lastDate was updated - Date based
  private updatedAtMs: number; // When lastDate was updated - performance based

  constructor() {
    this.set(new Date()); // Sets a default Date based on users browser

    // Cuando el usuario vuelve al tab (ej: después de despertar la laptop),
    // actualizar la fecha base para que get() refleje la fecha real del navegador
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.set(new Date());
        }
      });
    }
  }

  public set(d: Date): void {
    this.lastDate = d;

    if (performance) this.updatedAtMs = performance.now(); // Updates updatedAtMs milliseconds
    else this.updatedAt = new Date(); // Updates updatedAt date
  }

  public get(): Date {
    let calculatedDate: Date;

    if (this.updatedAtMs) {
      calculatedDate = new Date(this.lastDate.getTime() + performance.now() - this.updatedAtMs); // Adds difference to lastDate
    } else {
      const now = new Date();
      calculatedDate = new Date(this.lastDate.getTime() + now.getTime() - this.updatedAt.getTime()); // Adds difference to lastDate
    }

    // Si la fecha calculada es menor a la del navegador (ej: laptop suspendida),
    // usar la fecha del navegador como fallback
    const browserDate = new Date();
    return calculatedDate > browserDate ? calculatedDate : browserDate;
  }
}
